<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useCookieConsent } from './composables/useCookieConsent'
import './assets/silktide-consent-manager.css'

export default {
  components: { Navbar, Footer },
  setup() {
    const route = useRoute()
    const isAdmin = computed(() => route.path.startsWith('/admin'))
    useCookieConsent()
    return { isAdmin }
  },
}
</script>

<template>
  <div class="app">
    <Navbar v-if="!isAdmin" />
    <main class="main-content">
      <router-view />
    </main>
    <Footer v-if="!isAdmin" />
  </div>
</template>

<style>
.app { min-height: 100vh; display: flex; flex-direction: column; }
.main-content { flex: 1; }
</style>
